export class SYNC_MESSENGER_MESSAGE_TYPES {

  static readonly undefined = <string>undefined; // Some messages do not have property event.data.type (for example, the 'INITIALIZE' Angular Service Worker message)

  static readonly clientClaimRequest = 'clientClaimRequest';

  static readonly networkOnline = 'networkOnline';
  static readonly networkOffline = 'networkOffline';

  static readonly syncRequest = 'syncRequest';
  static readonly syncStarted = 'syncStarted';
  static readonly syncProgress = 'syncProgress';
  static readonly syncEnded = 'syncEnded';
  static readonly syncStatusUpdate = 'syncStatusUpdate';

  static readonly diagnosticExportRequest = 'diagnosticExportRequest';
  static readonly diagnosticExportStarted = 'diagnosticExportStarted';
  static readonly diagnosticExportEnded = 'diagnosticExportEnded';

  static readonly syncEntityRequest = 'syncEntityRequest';
  static readonly syncEntityProgress = 'syncEntityProgress';
  static readonly syncEntityStarted = 'syncEntityStarted';
  static readonly syncEntityEnded = 'syncEntityEnded';

  static readonly discardEntityRequest = 'discardEntityRequest';
  static readonly discardEntityStarted = 'discardEntityStarted';
  static readonly discardEntityProgress = 'discardEntityProgress';
  static readonly discardEntityEnded = 'discardEntityEnded';
}

export class BROADCAST_MESSENGER_CHANNELS {
  // Add if needed, for example:
  // static readonly test = {
  //   channelName: 'test',
  //   messageTypes: {
  //     workerToApp: 'workerToApp',
  //     appToWorker: 'appToWorker'
  //   }
  // } as const;
};
